export class InstituteDTO {
    id!: number;
    name?: string;
    companyName?: string;
    address?: string;
    location?: string;
    isTestLab?: boolean;
    isTestingBody?: boolean;
    isCertificationBody?: boolean;
    order?: number;
    instituteTypeId: number;
    instituteInstituteType:[]=[];
    isActive?: boolean;
    
  }